import React from 'react';
import { IoClose } from 'react-icons/io5';
import * as S from './SelectModal.styles';

interface SelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  options: any[];
  selectedValue: string | null;
  onSelect: (option: any) => void;
}

export const SelectModal: React.FC<SelectModalProps> = ({
  isOpen,
  onClose,
  options,
  selectedValue,
  onSelect
}) => {
  React.useEffect(() => {
    if (isOpen && selectedValue) {
      const selectedElement = document.querySelector(`[data-value="${selectedValue}"]`);
      if (selectedElement) {
        selectedElement.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
  }, [isOpen, selectedValue]);

  if (!isOpen) return null;

  return (
    <S.Overlay onClick={onClose}>
      <S.ModalContent>
        <S.CloseButton onClick={onClose}>
          <IoClose size={24} />
        </S.CloseButton>
        <S.OptionsList className="scrollable">
          {options.map(option => {
            const isDisabled = option.eventCount === 0 && option.value !== null;
            return (
              <S.Option
                key={option.value}
                data-value={option.value}
                $isSelected={option.value === selectedValue}
                $isDisabled={isDisabled}
                onClick={() => {
                  if (!isDisabled) {
                    onSelect(option);
                    onClose();
                  }
                }}
              >
                {option.label}
              </S.Option>
            );
          })}
        </S.OptionsList>
      </S.ModalContent>
    </S.Overlay>
  );
}; 